import {Component, Fragment, h, RenderableProps} from "preact";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import {connect, Provider} from "react-redux";
import {store} from "../_rx/store";
import {fetchIsLoggedIn, logout} from "../_rx/_auth/actions";
import {rndStr} from '../_common/common';
import {CompanyCompany, CompanyUser} from "../_api";
import {Notify} from "../_common/components/notify";

import Company from '../company/company';
import CompanyNew from '../company/companyNew';
import CompanyLogin from '../company/companyLogin';
import CompanyEdit from '../company/companyEdit';
import Candidate from '../candidate/candidate';
import Offers from '../offers/offers';
import Offer from "../offer/offer";
import OfferEdit from "../offerEdit/offerEdit";
import OfferPreview from '../offerPreview/offerPreview';
import User from "../user/user";
import UserEdit from "../user/userEdit";
import UserPassword from "../user/userChangePassword";
import UserEmail from "../user/userChangeEmail";
import CompanyPreview from "../company/companyPreview";

import {clearNotification} from "../_rx/_notify/actions";
import {t} from "../_i18n";

import Header, {computeAppLinks} from './header';

import '../theme/theme.scss';
import {Toast, toastService} from "../_services/toast-service";

const ToastList = ({toasts}:{toasts:Toast[]})=>{
    if(!toasts.length) return null;
    const types:any = {'info': 'success', 'danger': 'danger'};
    return <div className="toast-container top">
        {toasts.map(t=> <div key={t.key} className={'toast ' + types[t.type]}>
            {t.type=='info'?
                <i class="fas fa-check-circle" />:
                <i class="far fa-exclamation-circle" />} &nbsp;
            {t.message}
        </div> )}
    </div>;
};

type Props = {
    company: CompanyCompany,
    loggedUser: CompanyUser,
    notify: any
    fetchIsLoggedIn: typeof fetchIsLoggedIn
}

let App : any = class extends Component<Props,{}>{

    // history = useHistory();
    // app_dispatch = new AppDispatch();
    state = {toasts: [], languageIsSet:false};
    appLinks = computeAppLinks();

    showToastCB(t:Toast){
        t.key = rndStr();
        this.setState({toasts: [...this.state.toasts, t]});
        setTimeout(()=>{
            this.setState({toasts: this.state.toasts.filter(i=>i!==t)});
        }, 5000);

    }

    componentDidMount() {
        toastService.setCallback((t)=>this.showToastCB(t));
        this.props.fetchIsLoggedIn();
    }

    render ({company, loggedUser, notify}:Props) {

        const isLoading = loggedUser === null;

        return <Fragment>
            <Notify notifs={notify} onClear={clearNotification} />
            <ToastList toasts={this.state.toasts} />
            {isLoading ?
             <div id="loader-container">
                 <div class="text-loader delayed">{t('Cargando')}...</div>
             </div> :
             <Fragment>
                 {!loggedUser ? <Fragment>
                     <Switch>
                         <Route path="/company/new" exact component={CompanyNew} />
                         <Route path="/company/login" exact component={CompanyLogin} />
                         <Redirect to="/company/login" />
                     </Switch>
                 </Fragment> : <Fragment>
                     <Header appLinks={this.appLinks} company={this.props.company} />

                     <Switch>
                         <Route path="/company/login" exact><Redirect to="/offers" /></Route>
                         <Route path="/company/new" exact><Redirect to="/offers" /></Route>
                         <Route path="/company" exact component={Company} />
                         <Route path="/company/preview" exact component={CompanyPreview} />
                         <Route path="/company/preview/offers/:page?" exact component={CompanyPreview} />
                         <Route path="/company/edit" exact component={CompanyEdit} />
                         <Route path="/user" exact component={User} />
                         <Route path="/user/edit" exact component={UserEdit} />
                         <Route path="/user/password" exact component={UserPassword} />
                         <Route path="/user/email" exact component={UserEmail} />
                         <Route path="/offers/:page?" exact children={({ match, history }) => <Offers status='active' match={match} history={history}/>} />
                         <Route path="/archived/:page?" exact children={({ match, history }) => <Offers status='archived' match={match} history={history}/>} />
                         <Route path="/drafts/:page?" exact children={({ match, history }) => <Offers status='drafts' match={match} history={history}/> } />
                         <Route path="/candidate/:id(\d+)" exact component={Candidate} />
                         <Route path="/offers/:id(\d+)/preview" exact component={OfferPreview} />
                         <Route path="/offers/:id(\d+)/edit" exact component={OfferEdit} />
                         <Route path="/offers/:id(\d+)/:status([a-z]+)" component={Offer} />
                         <Route path="/new" exact component={OfferEdit} />
                         <Route path="/" exact><Redirect to="/offers" /></Route>
                     </Switch>

                 </Fragment>}
             </Fragment>
            }
        </Fragment>;

        return <div>App</div>
    }

}


App = connect(
    ({notify, auth:{loggedUser}, company}:any) => ({notify, loggedUser, company}),
    { logout, fetchIsLoggedIn }
    )(App as any) as any;


// App con store normal
export default ()=> <BrowserRouter>
    <Provider store={store}>
        <App />
    </Provider>
</BrowserRouter>;
